export default __webpack_public_path__ + "assets/northbank_logo_vertical.fe6c3cb7.svg";